module.exports = __webpack_public_path__ + "img/ws.67d4d6b7.png";